import Lottie from 'lottie-react'
import yogaAnimation from '../../assets/animations/yoga.json'

interface YogaIconProps {
  className?: string
  size?: number
}

const YogaIcon = ({ className = "w-14 h-14", size }: YogaIconProps) => {
  return (
    <div className={className} style={{ aspectRatio: '1 / 1', contain: 'layout' }}>
      <div className="dark:invert dark:brightness-0 dark:contrast-200 w-full h-full">
        <Lottie
          animationData={yogaAnimation}
          loop={true}
          autoplay={true}
          style={{ width: size || '100%', height: size || '100%' }}
          rendererSettings={{
            preserveAspectRatio: 'xMidYMid meet'
          }}
        />
      </div>
    </div>
  )
}

export default YogaIcon